import Weekday from "./DayPickerCustomWeekday";

export default Weekday;